export type PhaseInfo = {
  minPly: number;
  maxPly: number;
  label: string;
  goal: string;
};

export const PHASES: PhaseInfo[] = [
  {
    minPly: 1,
    maxPly: 8,
    label: "Claim the center",
    goal: "Fight for the center. Put a pawn on e4 or d4, then develop a knight toward it.",
  },
  {
    minPly: 9,
    maxPly: 16,
    label: "Develop & coordinate",
    goal: "Get every minor piece into play and tuck your king away.",
  },
  {
    minPly: 17,
    maxPly: 24,
    label: "King safety & structure",
    goal: "Finish development, then find a plan — a file, a diagonal, a weakness.",
  },
  {
    minPly: 25,
    maxPly: 30,
    label: "Plan & pressure",
    goal: "Pick a target and aim multiple pieces at it.",
  },
];

export const MAX_PLIES = 30;

/** Past move fifteen the course is over; coaching continues from the board. */
export const MIDDLEGAME_PHASE: PhaseInfo = {
  minPly: MAX_PLIES + 1,
  maxPly: Number.POSITIVE_INFINITY,
  label: "Middlegame",
  goal: "The opening is complete. Choose a plan from the pawn structure and improve your worst piece.",
};

/** Report cards arrive after every fifth White move. */
export const REPORT_CARD_EVERY = 5;

export function phaseForPlyCount(ply: number): PhaseInfo {
  if (ply > MAX_PLIES) return MIDDLEGAME_PHASE;
  return (
    PHASES.find(
      (p) => Math.min(ply, MAX_PLIES) >= p.minPly && Math.min(ply, MAX_PLIES) <= p.maxPly
    ) || PHASES[0]
  );
}

/**
 * The stage goal for a course: the first stage's "put a pawn on e4 or d4"
 * does not fit a flank opening.
 */
export function phaseGoalFor(openingId: string | null | undefined, ply: number): string {
  const phase = phaseForPlyCount(ply);
  if (openingId === "english" && phase === PHASES[0]) {
    return "Fight for the center from the flank: c4 and Nc3 aim at d5, and the g2-bishop joins in.";
  }
  return phase.goal;
}

export function whiteMoveNumber(ply: number): number {
  return Math.ceil(Math.max(0, ply) / 2);
}
